import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import AddBlogLayer from "../../components/AddBlogLayer";
import MasterLayout from "../../masterLayout/MasterLayout";
import AddBlog from "../../components/AddBlog/AddBlog";
import AddCaseStudy from "../../components/AddCaseStudy/AddCaseStudy";
import EditCaseStudy from "../../components/EditCaseStudy/EditCaseStudy";
const EditCaseStudyPage = () => {
    return (
        <>
            <MasterLayout>
                <Breadcrumb title='Edit Case Study' />

                <EditCaseStudy />
            </MasterLayout>
        </>
    );
};

export default EditCaseStudyPage;
